import React, {useState} from 'react';
import { Button, Input, Row, Col } from 'antd';
import { DIALOG_KEY } from "../../shared/utils/enum";
import toast from "react-hot-toast";
import { useCountryData } from "./useCountryData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import { useMailTitle, useUpdateMailTitle } from "./useMailTitle";
import {DeleteButton} from "../../shared/components/buttons/CustomButtons";

const defaultMailTitleData = (uniqueLangCode) => {
    const titleData = {};
    uniqueLangCode.forEach((lang) => {
        titleData[lang] = '';
    });
    return {
        index: 0,
        ...titleData
    }
}

const MailTitleEditModal = ({record, handleClose, dialogRef, handleSetDialog}) => {
    const { data: countryData, isLoading, error } = useCountryData();
    const { data: mailTitleData, isLoading: isMailTitleLoading, error: isMailTitleError } = useMailTitle();
    const { mutateAsync: updateMailTitle, isPending } = useUpdateMailTitle();
    const [uniqueLangCode] = useState([...new Set(countryData.map((row) => row.langCode))]);
    const [rows, setRows] = useState(record.index >= 0 ? record : defaultMailTitleData(uniqueLangCode));

    const countryInfo = {...countryData};

    const handleSetRows = (e) => {
        const {name, value} = e.target;
        setRows((prevRows) => ({
            ...prevRows,
            [name]: value
        }));
    };

    const handleSetMailTitle = async () => {
        const existingRowIndex = mailTitleData.findIndex((row) => row.index === rows.index);
        const {index, ...rest} = rows;
        const title = Object.entries(rest).map(([langCode, text]) => ({
            langCode,
            text
        }));
        const newRow = {
            index: parseInt(index),
            title
        }
        const updatedRows = [...mailTitleData];
        if (existingRowIndex >= 0) {
            updatedRows[existingRowIndex] = newRow;
        } else {
            updatedRows.push(newRow);
        }
        await handleSave(updatedRows);
    }

    const handleSave = async (updateData) => {
        await updateMailTitle({mailTitleData: updateData}, {
            onSuccess: () => {
                handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
                handleClose();
            }
        }).catch((err) => console.error(err));
    }

    const handleDelete = async (e) => {
        e.preventDefault();
        const currentDialog = dialogRef.current;
        if (currentDialog.confirmText === 'DELETE') {
           await handleSave(mailTitleData.filter((mailTitle) => mailTitle.index !== rows.index));
        } else {
            toast.error("잘못된 확인 문자입니다. DELETE 를 입력하세요.");
            handleSetDialog([{key: DIALOG_KEY.CONFIRM_TEXT, value: ''}]);
        }
    }

    if (isLoading || isMailTitleLoading) return <IsLoading />;
    const firstError = error || isMailTitleError;
    if (firstError) return <ErrorPage error={firstError}/>;

    return (
        <div>
            <Row gutter={16} style={{ flexDirection: 'column', alignItems: 'center', marginTop: 24 }}>
                <Col span={24}>
                    <Input
                        type="number"
                        name={'index'}
                        value={rows.index}
                        placeholder="인덱스"
                        style={{width: '800px', margin: '5px'}}
                        onChange={handleSetRows}
                    />
                </Col>
                {uniqueLangCode.map((lang) => (
                    <Col span={24} key={lang}>
                        <Input
                            name={lang}
                            value={rows[lang]}
                            placeholder={lang}
                            style={{width: '800px', margin: '5px'}}
                            onChange={handleSetRows}
                        />
                    </Col>
                ))}
            </Row>
            <Row justify="end" gutter={8} style={{ marginTop: 24 }}>
                <Col>
                    <Button type="primary" loading={isPending} onClick={handleSetMailTitle}>저장</Button>
                </Col>
                <Col>
                    <Button onClick={handleClose}>취소</Button>
                </Col>
                <Col>
                    {rows.index > 0 && (
                        <DeleteButton onClick={handleDelete} display={rows.seq === 0 ? 'none' : 'flex'}
                                      handleSetDialog={handleSetDialog}/>
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default MailTitleEditModal;